import { CreateApiReturnType } from '../methods.api';
import { CreateApiBFFReturnType } from '../methods.apiBFF';

/**
 * ТАк как в frontend/src/api/fetcher.ts добавили интерсептор, который выводит "data",
 * типы всех результатов не верны, поэтому делаем обертку
 */

class ApiManager {
  private api!: CreateApiReturnType;

  setApi(api: CreateApiReturnType) {
    this.api = api;
  }

  get $api(): CreateApiReturnType {
    if (!this.api) {
      throw new Error('use setApi before call');
    }
    return this.api;
  }

  private apiBFF!: CreateApiBFFReturnType;

  setApiBFF(apiBFF: CreateApiBFFReturnType) {
    this.apiBFF = apiBFF;
  }

  get $apiBFF(): CreateApiBFFReturnType {
    if (!this.apiBFF) {
      throw new Error('use setApiBFF before call');
    }
    return this.apiBFF;
  }
}

const apiManager = new ApiManager();

export { apiManager };
